import { useFeatureOverride } from 'src/Hooks/useFeatureOverride'
import { SessionFeatures } from 'src/Hooks/useSessionFeature'

export const useSwitchHeatEnabled = () => useFeatureOverride(SessionFeatures.EnableSwitchHeat)
